import { fetchOrReportFailure } from '../../utilities/network-failure';

const getToken = (): string => {
  const urlParts = window.location.pathname.split('/');
  const buyerToken = urlParts.pop();
  if (!buyerToken) throw new Error('jwt token required');
  return buyerToken;
};

const fetchWithToken = (url: string, options: RequestInit) => {
  const authHeaders = {
    authorization: `Bearer ${getToken()}`,
  };
  return fetchOrReportFailure(url, {
    ...options,
    credentials: 'include',
    headers: {
      ...options.headers,
      ...authHeaders,
    },
  });
};

const fetchUnauthed = (url: string, options: RequestInit) =>
  fetchOrReportFailure(url, {
    ...options,
    headers: {
      ...options.headers,
    },
  });

const downloadFile = (data: string, filename: string, mime: string, bom: string) => {
  const blobData = typeof bom !== 'undefined' ? [bom, data] : [data];
  const blob = new Blob(blobData, { type: mime || 'application/octet-stream' });
  const blobURL = window.URL && window.URL.createObjectURL ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
  const tempLink = document.createElement('a');
  tempLink.style.display = 'none';
  tempLink.href = blobURL;
  tempLink.setAttribute('download', filename);

  // Safari thinks _blank anchor are pop ups. We only want to set _blank
  // target if the browser does not support the HTML5 download attribute.
  // This allows you to download files in desktop safari if pop up blocking
  // is enabled.
  if (typeof tempLink.download === 'undefined') {
    tempLink.setAttribute('target', '_blank');
  }

  document.body.appendChild(tempLink);
  tempLink.click();

  // Fixes "webkit blob resource error 1"
  setTimeout(() => {
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(blobURL);
  }, 200);
};

export { fetchWithToken, fetchUnauthed, downloadFile };
